import { StoreState } from '@/redux/types';

export function getCore(state: StoreState) {
  return state.core;
}
